import "../Style/TableContainer.css"
import { useState, useEffect, useRef, useContext } from "react";


import DataTable from './DataTable';
import Filter from './Filter';
import IndexWrapper from './IndexWrapper';
import LastUpdateTime from './LastUpdateTime';
import Version from './Version';
import RailwayMap from './RailwayMap';

import TrainloadContext from "../Store/trainload-context";



// import config from "../Config/config";

const TableContainer = (props) => {

    // const [title, setTitle] = useState("no title");
    // const [result, setResult] = useState([]);
    const [firstFetch, setFirstFetch] = useState(true);

    const [config, setConfig] = useState(props.config);
    const [traintypes, setTraintypes] = useState(props.traintypes);

    // const [funnel, setFunnel] = useState({}); // store sorting functions

    const trainloadCtx = useContext(TrainloadContext);

    const TrainloadDataRef = useRef(null);

    // const triggerChildFunction = () => {
    //     TrainloadDataRef.current.handleFilterByTrainType();
    // };

    const triggerReloadFunction = () => {
        trainloadCtx.clearTrainloadData();
        fetchData();
    };

    const triggerTraintypeFilterFunction = (traintype) => {
        TrainloadDataRef.current.handleFilterByTrainType(traintype);
    };

    const triggerKeywordFilterFunction = (keyword) => {
        TrainloadDataRef.current.handleFilterByKeyword(keyword);
    }

    const triggerShowUpDirectionFilterFunction = (isShow) => {
        TrainloadDataRef.current.handleFilterByShowUpDirection(isShow, config.up_trick_dest_stations);
    }

    const triggerShowDownDirectionFilterFunction = (isShow) => {
        TrainloadDataRef.current.handleFilterByShowDownDirection(isShow, config.down_trick_dest_stations);
    }

    const triggerStationFilterFunction = (station_arr) => {
        TrainloadDataRef.current.handleFilterByStation(station_arr);
    }



    const fetchData = async () => {
        try {
            let response = await fetch(config.web_api, {
                method: "GET",
                headers: {
                    "x-api-key": config.web_api_key,
                },
                signal: AbortSignal.timeout(10000),
            });
            //console.log(response)
            let result = await response.json();
            // console.log("Fetch result", result);

            console.log("qwerty");
            console.log(result);

            const data = result.reduce((obj, item) => {
                obj[item.trainId] = item;
                return obj;
            }, {});
            console.log("fghjk");
            console.log(data);


            // setResult(result);
            //return result;
            // console.log("updated funnel: ", trainloadCtx.funnel);
            trainloadCtx.updateTrainloadData(data); // this will cause re-rendering

            document.getElementById("LastUpdateTime").innerHTML = new Date().toLocaleString('zh-HK', { timeZone: 'Asia/Hong_Kong', });
        } catch (err) {
            console.error(err);
        }
    }



    useEffect(
        () => {
            console.log("invoked useEffect");
            if (firstFetch) {
                console.log("First Fetch Data");
                fetchData(); // first time 
                setFirstFetch(prev => !prev);
            }



            let id = setInterval(() => {
                console.log("Fetch Data ...");
                fetchData();
            }, 3000); // 3 seconds fetch data
            // console.log("id", id);
            return () => clearInterval(id);

            // if ('URLSearchParams' in window) {
            //     var searchParams = new URLSearchParams(window.location.search);
            //     searchParams.set("traintype", "M");
            //     console.log(searchParams.get('traintype'));
            // //     window.location.search = searchParams.toString();
            // }
        }
        ,
        [trainloadCtx.funnel] //second argument, if the variables inside updated, re-invoke useEffect
    );



    return (

        <div className="table-container">

            <Filter
                stations={config.stations}
                traintypes={traintypes}
                triggerReloadFunction={triggerReloadFunction}
                triggerTraintypeFilterFunction={triggerTraintypeFilterFunction}
                triggerKeywordFilterFunction={triggerKeywordFilterFunction}
                triggerShowUpDirectionFilterFunction={triggerShowUpDirectionFilterFunction}
                triggerShowDownDirectionFilterFunction={triggerShowDownDirectionFilterFunction}

                triggerStationFilterFunction={triggerStationFilterFunction}

            >
            </Filter>



            {/* <RailwayMap stations={config.stations} line_color={config.line_color}></RailwayMap> */}



            <div className="info-wrapper">
                <IndexWrapper index_label={props.index_label}></IndexWrapper>
                <LastUpdateTime></LastUpdateTime>
            </div>








            {/* <DataTable trainloaddata={result} ref={TrainloadDataRef}></DataTable> */}
            <DataTable trainloaddata={trainloadCtx.trainloaddata} ref={TrainloadDataRef}></DataTable>


            <Version></Version>
        </div>

    );
}

export default TableContainer;